import styles from "./styles.scss";
import { ErrorBoundary } from "./error-boundary";
import { ErrorScreen } from "@/components";
import { ErrorBoundaryPageProps } from "./types";
import { withRouter } from "./utils";

class ErrorBoundaryPageContent extends ErrorBoundary<ErrorBoundaryPageProps> {
  public componentDidUpdate(prevProps: ErrorBoundaryPageProps) {
    const { hasError } = this.state;
    const { pathname: prevPathname } = prevProps.location;
    const { pathname: currentPathname } = this.props.location;

    if (prevPathname !== currentPathname && hasError) {
      this.setState({
        hasError: false,
      });
    }
  }

  public render() {
    if (this.state.hasError) {
      return (
        <ErrorScreen
          titleClassName={styles.errorTitle}
          subtitleClassName={styles.errorSubTitle}
        />
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundaryPage = withRouter(ErrorBoundaryPageContent);
